
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/settings",
      function () {
        return require("private-next-pages/d/account/settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/settings"])
      });
    }
  